export default __webpack_public_path__ + "static/media/ALLERGEN_MUSTARD.3ab36ffa.png";